import { useEffect, useState, useCallback } from 'react'
import { ClipboardList, Search, Eye, X, History, AlertTriangle, PencilLine } from 'lucide-react'
import api from '../api/client'
import Pagination from '../components/Pagination'
import Loader from '../components/Loader'
import SearchableSelect from '../components/SearchableSelect'
import CorrecaoConexao from '../components/CorrecaoConexao'

// Visão do LICENCIADO — apenas acompanhamento (sem aprovar/reprovar/alterar status).
const STATUS = {
  rascunho: { label: 'Rascunho', cls: 'bg-neutral-100 text-neutral-700 border-neutral-200' },
  analise: { label: 'Em Análise', cls: 'bg-primary-100 text-primary-800 border-primary-300' },
  correcao: { label: 'Correção Solicitada', cls: 'bg-amber-100 text-amber-800 border-amber-300' },
  doc_pendente: { label: 'Documentação Pendente', cls: 'bg-accent-100 text-accent-800 border-accent-300' },
  aprovado: { label: 'Aprovado', cls: 'bg-emerald-100 text-emerald-800 border-emerald-300' },
  reprovado: { label: 'Reprovado', cls: 'bg-red-100 text-red-800 border-red-300' },
  conexao_usina: { label: 'Envio para a Usina', cls: 'bg-sky-100 text-sky-800 border-sky-300' },
  conexao_rateio_proc: { label: 'Rateio em Processamento', cls: 'bg-sky-100 text-sky-800 border-sky-300' },
  conexao_rateio_enviado: { label: 'Rateio Enviado', cls: 'bg-sky-100 text-sky-800 border-sky-300' },
  conexao_concessionaria: { label: 'Aguardando Concessionária', cls: 'bg-indigo-100 text-indigo-800 border-indigo-300' },
  conexao_ativacao: { label: 'Em Ativação', cls: 'bg-violet-100 text-violet-800 border-violet-300' },
  ativo: { label: 'Recebendo Créditos', cls: 'bg-emerald-100 text-emerald-800 border-emerald-300' },
}
const fmtData = (v) => (v ? new Date(v).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' }) : '-')
const Chip = ({ s }) => <span className={`inline-block px-2.5 py-0.5 rounded-full text-[11px] font-bold border ${(STATUS[s] || {}).cls || 'bg-neutral-100 text-neutral-700'}`}>{(STATUS[s] || {}).label || s}</span>

function DetalheModal({ item, onClose, onCorrigir }) {
  const [det, setDet] = useState(null)
  const [hist, setHist] = useState([])
  useEffect(() => {
    api.get(`/contratos-adesao/${item.id}`).then((r) => setDet(r.data)).catch(() => {})
    api.get(`/contratos-adesao/${item.id}/historico`).then((r) => setHist(r.data.items || [])).catch(() => {})
  }, [item.id])
  const d = det || item
  const emCorrecao = ['correcao', 'doc_pendente'].includes(d.status)

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-xl bg-white rounded-2xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col">
        <div className="px-5 py-4 bg-gradient-to-r from-primary-50 to-accent-50 border-b border-primary-100 flex items-center gap-3">
          <div className="flex-1 min-w-0">
            <h3 className="font-heading font-extrabold text-graphite truncate">{d.cliente_nome || 'Sem cliente'}</h3>
            <Chip s={d.status} />
          </div>
          <button onClick={onClose} className="text-neutral-400 hover:text-graphite"><X size={20} /></button>
        </div>
        <div className="p-5 overflow-y-auto tc-scroll space-y-4">
          {emCorrecao && d.motivo_correcao && (
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-3">
              <p className="text-sm font-semibold text-amber-800 flex items-center gap-1.5"><AlertTriangle size={15} /> Correção solicitada</p>
              <p className="text-xs text-amber-700 mt-1 whitespace-pre-line">{d.motivo_correcao}</p>
              <button onClick={() => { onCorrigir(d.id); }}
                className="mt-2 inline-flex items-center gap-1 text-xs font-bold text-white bg-accent-500 hover:bg-accent-600 rounded-lg px-3 py-1.5"><AlertTriangle size={12} /> Corrigir cadastro</button>
            </div>
          )}
          {d.status === 'reprovado' && d.motivo_reprovacao && (
            <p className="text-xs text-red-700 bg-red-50 rounded-lg px-3 py-2"><b>Motivo da reprovação:</b> {d.motivo_reprovacao}</p>
          )}
          <div className="grid grid-cols-2 gap-3 text-sm">
            <Info label="CPF/CNPJ" value={d.cliente_cpf_cnpj} />
            <Info label="Produto" value={d.oferta_nome || d.plano_descricao || d.tipo_conexao} />
            <Info label="Distribuidora" value={d.distribuidora_nome || d.distribuidora?.nome} />
            <Info label="Data do cadastro" value={fmtData(d.created_at)} />
          </div>
          {hist.length > 0 && (
            <div>
              <p className="text-xs font-bold uppercase tracking-wider text-neutral-500 mb-2 flex items-center gap-1.5"><History size={13} /> Acompanhamento</p>
              <div className="space-y-1.5">
                {hist.map((h, i) => (
                  <div key={i} className="text-xs text-neutral-600 flex gap-2">
                    <span className="text-neutral-400 whitespace-nowrap">{fmtData(h.created_at)}</span>
                    <span>{h.mensagem || (STATUS[h.status_novo] || {}).label || h.acao}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
const Info = ({ label, value }) => (
  <div><p className="text-[11px] uppercase tracking-wider text-neutral-400">{label}</p><p className="text-sm text-graphite font-medium">{value || '-'}</p></div>
)

export default function MinhasConexoes() {
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(20)
  const [pages, setPages] = useState(1)
  const [total, setTotal] = useState(0)
  const [busca, setBusca] = useState('')
  const [debounced, setDebounced] = useState('')
  const [status, setStatus] = useState('todos')
  const [sel, setSel] = useState(null)
  const [corrigir, setCorrigir] = useState(null)

  useEffect(() => { const t = setTimeout(() => setDebounced(busca), 300); return () => clearTimeout(t) }, [busca])

  const load = useCallback(() => {
    setLoading(true)
    const params = { page, limit: size }
    if (status !== 'todos') params.status = status
    if (debounced) params.search = debounced
    api.get('/contratos-adesao', { params }).then((r) => {
      setRows(r.data.data || []); setPages(r.data.pages || 1); setTotal(r.data.total || 0)
    }).catch(() => setRows([])).finally(() => setLoading(false))
  }, [page, size, status, debounced])
  useEffect(() => { load() }, [load])

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-xl sm:text-2xl font-heading font-extrabold text-graphite flex items-center gap-2">
          <ClipboardList size={24} className="text-accent-500" /> Minhas Conexões
        </h1>
        <p className="text-sm text-neutral-500 mt-1">Acompanhe o andamento dos seus cadastros — da análise até o cliente ativo</p>
      </div>

      <div className="bg-white rounded-2xl border border-neutral-200 shadow-sm p-3 flex flex-wrap gap-3 items-center">
        <div className="flex-1 min-w-[220px] relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400" />
          <input value={busca} onChange={(e) => { setBusca(e.target.value); setPage(1) }} placeholder="Buscar..."
            className="w-full pl-10 pr-3 py-2 rounded-xl border border-neutral-200 text-sm focus:border-accent-400 focus:ring-2 focus:ring-accent-100 outline-none" />
        </div>
        <SearchableSelect value={status} onChange={(v) => { setStatus(v); setPage(1) }} emptyOption={false} className="w-56"
          options={[{ value: 'todos', label: 'Todos os status' }, ...Object.entries(STATUS).map(([v, o]) => ({ value: v, label: o.label }))]} />
      </div>

      {loading ? (
        <div className="flex justify-center py-20"><Loader text="Carregando..." /></div>
      ) : (
        <div className="bg-white rounded-2xl shadow-sm border border-neutral-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-gradient-to-r from-primary-50 to-accent-50 border-b border-primary-100">
                  <th className="text-left px-4 py-3 text-xs font-bold text-graphite uppercase tracking-wider">Cliente</th>
                  <th className="text-left px-4 py-3 text-xs font-bold text-graphite uppercase tracking-wider hidden md:table-cell">Produto</th>
                  <th className="text-center px-4 py-3 text-xs font-bold text-graphite uppercase tracking-wider">Status</th>
                  <th className="text-center px-4 py-3 text-xs font-bold text-graphite uppercase tracking-wider hidden lg:table-cell">Cadastro</th>
                  <th className="text-right px-4 py-3 text-xs font-bold text-graphite uppercase tracking-wider">Ver</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr><td colSpan={5} className="text-center py-16 text-neutral-400">
                    <ClipboardList size={40} className="mx-auto mb-2 opacity-30" /><p>Nenhuma conexão ainda</p>
                  </td></tr>
                ) : rows.map((v) => (
                  <tr key={v.id} onClick={() => setSel(v)} className="border-b border-neutral-100 hover:bg-primary-50/40 cursor-pointer">
                    <td className="px-4 py-3">
                      <p className="text-sm font-semibold text-graphite truncate">{v.cliente_nome || 'Sem cliente'}</p>
                      <p className="text-[11px] text-neutral-400 truncate">{v.cliente_cpf_cnpj || ''}</p>
                    </td>
                    <td className="px-4 py-3 hidden md:table-cell text-sm text-neutral-600">{v.oferta_nome || v.plano_descricao || v.tipo_conexao || '-'}</td>
                    <td className="px-4 py-3 text-center"><Chip s={v.status} /></td>
                    <td className="px-4 py-3 text-center text-xs text-neutral-500 hidden lg:table-cell">{fmtData(v.created_at)}</td>
                    <td className="px-4 py-3 text-right whitespace-nowrap">
                      {['correcao', 'doc_pendente'].includes(v.status) && (
                        <button onClick={(e) => { e.stopPropagation(); setCorrigir(v.id) }} title="Corrigir" className="p-2 rounded-lg hover:bg-amber-100 text-amber-600"><PencilLine size={16} /></button>
                      )}
                      <button onClick={(e) => { e.stopPropagation(); setSel(v) }} className="p-2 rounded-lg hover:bg-accent-100 text-accent-600"><Eye size={16} /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {total > 0 && (
            <div className="px-4 py-3 border-t border-neutral-100">
              <Pagination page={page} pages={pages} total={total} pageSize={size} onPage={setPage} onPageSize={(n) => { setSize(n); setPage(1) }} />
            </div>
          )}
        </div>
      )}

      {sel && <DetalheModal item={sel} onClose={() => setSel(null)} onCorrigir={(id) => { setSel(null); setCorrigir(id) }} />}
      {corrigir && <CorrecaoConexao contratoId={corrigir} onClose={() => setCorrigir(null)} onDone={() => { setCorrigir(null); load() }} />}
    </div>
  )
}
